export const copyToClipboard = (str: string) => {
  const el = document.createElement("textarea");
  el.value = str;
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  const selected =
        document.getSelection().rangeCount > 0 // cCheck if there is any content selected previously
          ? document.getSelection().getRangeAt(0) // store selection if found
          : false;
  el.select();
  document.execCommand("copy"); // copy - only works as a result of a user action (e.g. click events)
  document.body.removeChild(el);
  if (selected) { // restore selection
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }
};
